// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".animate-width[data-v-6fe17912]{-webkit-transition:width .3s;transition:width .3s}", ""]);
// Exports
module.exports = exports;
